import type { Message } from '@interfaces/message';
import type { InputMessageReplyInfo } from '@store/types/input-message-reply-info';

import { useSelector } from '@/store';

export function selectInputMessageReplyInfo() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useSelector<InputMessageReplyInfo, Message | undefined>('inputMessageReplyInfo', (state) => {
    return state?.message;
  });
}
